export default __webpack_public_path__ + "static/media/DP1500i.c02defb7.jpg";